// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/billing/billing.actions.go

export const GET_BILLING_ACCOUNT =
  "mondoo.billing.BillingManager.GetBillingAccount";
